import React from 'react';
import { ComparisonPeriod } from 'src/shared/helpers/habitatComparison';
import { Tabs, TabsList, TabsTrigger } from 'src/shared/components/ui/tabs';

type ComparisonPeriodToggleProps = {
    value: ComparisonPeriod;
    onChange: (period: ComparisonPeriod) => void;
};

const ComparisonPeriodToggle = ({ value, onChange }: ComparisonPeriodToggleProps) => (
    <Tabs value={value} onValueChange={period => onChange(period as ComparisonPeriod)}>
        <TabsList>
            <TabsTrigger value='current'>Current year</TabsTrigger>
            <TabsTrigger value='lastFull'>Last full year</TabsTrigger>
        </TabsList>
    </Tabs>
);

export default ComparisonPeriodToggle;
